import { defineMessages } from 'react-intl'

export const PROFILE_WORKOUT_DURATION_GOAL = {
  UNDER_15: 'UNDER_15',
  BETWEEN_15_30: 'BETWEEN_15_30',
  BETWEEN_30_60: 'BETWEEN_30_60',
  OVER_60: 'OVER_60'
}

export const PROFILE_WORKOUT_DURATION_GOALS = Object.values(PROFILE_WORKOUT_DURATION_GOAL)

const labels = defineMessages({
  under15: {
    id: 'ProfileWorkoutDurationGoal.under15',
    defaultMessage: 'Under 15 minutes',
    description: 'User prefers workouts that last less than 15 minutes.'
  },
  between1530: {
    id: 'ProfileWorkoutDurationGoal.between1530',
    defaultMessage: '15–30 minutes',
    description: 'User prefers workouts lasting 15 to 30 minutes.'
  },
  between3060: {
    id: 'ProfileWorkoutDurationGoal.between3060',
    defaultMessage: '30–60 minutes',
    description: 'User prefers workouts lasting 30 to 60 minutes.'
  },
  over60: {
    id: 'ProfileWorkoutDurationGoal.over60',
    defaultMessage: 'Over 60 minutes',
    description: 'User prefers workouts lasting more than 60 minutes.'
  }
})

export const PROFILE_WORKOUT_DURATION_GOAL_MESSAGE = {
  [PROFILE_WORKOUT_DURATION_GOAL.UNDER_15]: labels.under15,
  [PROFILE_WORKOUT_DURATION_GOAL.BETWEEN_15_30]: labels.between1530,
  [PROFILE_WORKOUT_DURATION_GOAL.BETWEEN_30_60]: labels.between3060,
  [PROFILE_WORKOUT_DURATION_GOAL.OVER_60]: labels.over60
}

export const PROFILE_WORKOUT_DURATION_GOAL_EMOJI = {
  [PROFILE_WORKOUT_DURATION_GOAL.UNDER_15]: '⚡️',
  [PROFILE_WORKOUT_DURATION_GOAL.BETWEEN_15_30]: '⏱️',
  [PROFILE_WORKOUT_DURATION_GOAL.BETWEEN_30_60]: '⌛',
  [PROFILE_WORKOUT_DURATION_GOAL.OVER_60]: '🕰️'
}
